const {
  getSlugAndProductId,
  getSlug,
  deleteCompiledProductBySlug,
  refreshDataBySlug,
} = require('../../public/product/data');
const { isWarrantyProduct } = require('../../public/product/utils');
const { updateSkuField } = require('../productsDataMethod');

const TASKS = {
  CMS_PRODUCT_CHANGE: {
    name: 'CMSProductChanged',
    getIdentifier: getSlug,
    process: identifier => refreshDataBySlug(identifier, true),
    shouldSkipCheck: isWarrantyProduct,
    estimatedDurationSec: 2,
  },
  CMS_PRODUCT_CREATE: {
    name: 'CMSProductCreate',
    getIdentifier: getSlug,
    process: identifier => refreshDataBySlug(identifier, true),
    shouldSkipCheck: isWarrantyProduct,
    estimatedDurationSec: 2,
  },
  CMS_PRODUCT_DELETE: {
    name: 'CMSProductDelete',
    getIdentifier: getSlug,
    process: deleteCompiledProductBySlug,
    shouldSkipCheck: isWarrantyProduct,
    estimatedDurationSec: 2,
  },
  STORE_PRODUCT_CREATE: {
    name: 'StoresProductCreate',
    getIdentifier: getSlug,
    process: identifier => refreshDataBySlug(identifier, true),
    shouldSkipCheck: isWarrantyProduct,
    estimatedDurationSec: 2,
  },
  STORE_PRODUCT_CHANGE: {
    name: 'StoresProductChanged',
    getIdentifier: getSlug,
    process: identifier => refreshDataBySlug(identifier, true),
    shouldSkipCheck: isWarrantyProduct,
    estimatedDurationSec: 2,
  },
  STORE_PRODUCT_DELETE: {
    name: 'StoresProductDelete',
    getIdentifier: task => task.slug,
    process: deleteCompiledProductBySlug,
    shouldSkipCheck: isWarrantyProduct,
    estimatedDurationSec: 2,
  },
  CMS_PRODUCT_INITIALIZE_SKU: {
    name: 'CMSProductInitializeSku',
    getIdentifier: getSlugAndProductId,
    process: updateSkuField,
    shouldSkipCheck: () => false,
    estimatedDurationSec: 2,
  },
  CMS_PRODUCT_UPDATE_SKU: {
    name: 'CMSProductUpdateSku',
    getIdentifier: getSlugAndProductId,
    process: updateSkuField,
    shouldSkipCheck: () => false,
    estimatedDurationSec: 2,
  },
};

module.exports = { TASKS };
